export const transitionStudentTypes = Object.freeze({
  Saee12: 1,
  Saee12A: 2,
  Saee12B: 3
});
